import React, {ReactNode} from 'react';

interface ComBGProps {
    children?: ReactNode;
}

const ComBG: React.FC<ComBGProps> = (props) => {
    const {children} = props;
    return (
        <div className="com_bg" style={{
            backgroundImage: `url("/img/home_bg.webp")`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
        }}>
            {children}
        </div>
    );
};

export default ComBG;
